module.exports = __webpack_public_path__ + "img/5.024c0d63.svg";